import { z } from "zod";
import { BusinessType } from "@prisma/client-generated";

export { BusinessType };
export type { Business } from "@prisma/client-generated";

export const businessSchemaCreate = z.object({
  isJoint: z.boolean(),
  name: z.string(),
  businessType: z.nativeEnum(BusinessType),
  ownershipPercentage: z.number().int().min(0).max(100),
  valueInCents: z.number().min(0),
  currency: z.string().nullish(),
  userAPercentage: z.number().int().min(0).max(100).nullish(),
  userBPercentage: z.number().int().min(0).max(100).nullish(),
});

export const businessSchemaUpdate = businessSchemaCreate.partial();

export type BusinessCreateRequest = z.infer<typeof businessSchemaCreate>;
export type BusinessUpdateRequest = z.infer<typeof businessSchemaUpdate>;
